

export default class AdminApiKeys {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminAPIKeysRoute, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminAPIKeysRoute}/${id}/view-credentials`, {})
  }

  create(payload = {}) {
    return this.axiosIns.post(this.jwtConfig.main.adminAPIKeysRoute, payload)
  }

  revoke(api_key_id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminAPIKeysRoute}/${api_key_id}/revoke`, {});
  }

  fetchAPIKeyUsage(bank_api_key_id, params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminAPIKeysRoute}/${bank_api_key_id}/usage`, {
      params
    })
  }
}
